import { AreaWorkstationHistory } from '@/types/area'
import { useAreaStore } from '@/modules/Areas'
import { ModalTypes, useModal } from '@/components/Modal'

import styles from './WorkstationItem.module.scss'

import ChevronRightIcon from '../../../assets/chevron-right.svg'
import LockIcon from '../../../assets/lock.svg'
import { Link } from 'react-router-dom'
import { ROUTES } from '@/router'
import { useWorkstationSelect } from '@/modules/Workstation/hooks/useWorkstationSelect'

export const WorkstationItem = ({ workstation }: { workstation: AreaWorkstationHistory }) => {
    const { openModal } = useModal()
    const { handleWorkstationChange } = useWorkstationSelect()

    const { selectedAreaCode } = useAreaStore()
    const filteredRoutes =
        selectedAreaCode === 'night'
            ? workstation.routes.filter((route) => route.dayType === 'Night')
            : workstation.routes

    const handleOpenRouteDetails = (route: string) => {
        openModal(ModalTypes.routeDetailsModal, { route, workstationNumber: workstation.number, readOnly: true })
    }

    return (
        <div className={styles.workstationItem}>
            <div className={styles.header}>
                <Link
                    to={ROUTES.HOME}
                    onClick={() => handleWorkstationChange(workstation.number)}
                    className={styles.titleContainer}
                >
                    <div className={styles.lockContainer}>
                        <span className={styles.title}>{workstation.number}</span>
                        {workstation.isLocked && <LockIcon />}
                    </div>
                    <div className={styles.unfinishedContainer}>
                        {workstation.unfinishedRecordsCount > 0 && (
                            <span className={styles.unfinished}>{workstation.unfinishedRecordsCount} unfinished</span>
                        )}
                        <ChevronRightIcon />
                    </div>
                </Link>

                <div className={styles.shiftContainer}>
                    {workstation.userShifts.map((shift) => (
                        <span className={styles.shift} key={shift.dutyCode}>
                            {shift.authorName} <span className={styles.shiftCode}>{shift.dutyCode}</span>
                        </span>
                    ))}
                </div>
            </div>

            <div className={styles.routesContainer}>
                {filteredRoutes.map((route) => (
                    <div key={route.route} className={styles.route} onClick={() => handleOpenRouteDetails(route.route)}>
                        <div className={styles.chipContainer}>
                            <span className={styles.routeTitle}>{route.route}</span>
                        </div>

                        <span className={styles.strategy}>{route.strategy ?? '-'}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}
